<template>
  <div class="connections-view">
    <div class="connections-content">
      <SavedConnectionsManagement
        v-if="currentView === 'management'"
        @initiate-new-connection="currentView = 'setup'"
      />
      <ApiConnectionSetupWizard
        v-if="currentView === 'setup'"
        @connection-configuration-saved="currentView = 'management'"
        @cancel="currentView = 'management'"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import SavedConnectionsManagement from '@/Modules/ETL/components/SavedConnectionsManagement.vue'
import ApiConnectionSetupWizard from '@/Modules/ETL/components/ApiConnectionSetupWizard.vue'

const route = useRoute()

const currentView = ref(route.name === 'ETLNewConnection' ? 'setup' : 'management')

// Sync view when the user navigates between /ETL/connections and /ETL/connections/new
watch(
  () => route.name,
  (name) => {
    currentView.value = name === 'ETLNewConnection' ? 'setup' : 'management'
  }
)
</script>

<style scoped>
.connections-view {
  width: 100%;
  height: 100%;
}

.connections-content {
  width: 100%;
  height: 100%;
}
</style>
